import { RegisterForm } from "@/components/register-form";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

const registerSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/password/register/")({
  validateSearch: (search) => registerSearchSchema.parse(search),
  component: () => <RegisterForm />,
});
